export default __webpack_public_path__ + "static/media/empty-table.5b589f98.svg";